import { styled } from '@mui/material/styles';
import { SelectButtonStateProps } from '../model';

export const SelectButtonInput = styled('input', {
  name: 'Select',
  slot: 'Input',
})<{ ownerState: SelectButtonStateProps }>({
  bottom: 0,
  left: 0,
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: '100%',
  boxSizing: 'border-box',
});
